// DLC Client Config
// import { isProd } from "../env";
/* 
UPDATE adhoceons_cnp.keypair
SET value_vch='{"cnpmsgingsys": "centerpointenergy.com"}'
WHERE key_vch='EMAIL_DOMAINS';
*/
// Demo Client Config
import template from "./_template";

const cnp_config = {
  name: "cnp",
  disabled_features: {
    ...template.disabled_features,
    qa_header: true,
  },
  enabled_features: {
    ...template.enabled_features,
    // Optional features
    dataset_dip: true,
    dataset_import: true,
    inbound_message: true,
    emergency_campaign_priority: true,
    campaign_templates: true,
    wav_upload: true,
    url_shortner: true,
    optout_upload: true,
    suppress_optouts: true,
  },
  sms: {
    short_codes: [
      // { label: "94230", value: "94230" }, // REST DLC-109 Removed as certification has completed for their shortcodes
      { label: "SC # 91817", value: "91817" },
      { label: "SC # 68603", value: "68603" },
      { label: "SC MOD Campaign # 91837", value: "91837" },
      { label: "SC API Campaign # 46737", value: "46737" },
      { label: "SC Vanity # 69383", value: "69383" },
      { label: "SC EBill # 79091", value: "79091" },
      { label: "SC Billing # 62097", value: "62097" },
      { label: "SC Payment # 83258", value: "83258" },
    ],
  },
  voice: {
    premium_options: ["all"],
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { label: "Caller ID 1 # 713-207-2222", value: "7132072222" },
      { label: "Caller ID 2 # 812-464-4500", value: "8124644500" },
      { label: "Caller ID 3 # 800-477-4747", value: "8004774747" },
    ],
  },
};

export default cnp_config;
